<template>
    <div class="site-inactive">
      <h1 class="site-inactive__title">This Website is no longer active.</h1>
      <p class="site-inactive__message">
        Please reach out to your CCR Media Point of Contact with any questions
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: "SiteInactive",
  };
  </script>
  

<style lang="scss" scoped>
.site-inactive {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 100vh;
    padding: 1rem;
  }
  
  .site-inactive__title {
    margin: 0 0 0.75rem;
  }
  
  .site-inactive__message {
    max-width: 32rem;
    margin: 0;
    color: #6c757d;
  }
</style>